import ShoppingCart from '@/assets/icons/ShoppingCart.svg';
import { ImageLink } from '@/components/ImageLink';
import * as Styled from './CheckoutHeader.styled';

interface CheckoutHeaderProps {
  basketUrl?: string;
}

export const CheckoutHeader = ({ basketUrl }: CheckoutHeaderProps) => (
  <Styled.Header>
    <h1 className="visually-hidden">Checkout | Easons</h1>
    <Styled.InnerWrapper>
      <ImageLink href="/" label="Go to Easons homepage">
        <img
          alt="Easons logo"
          height={28}
          width={133}
          src="/Styles/Images/eason-logo.png"
        />
      </ImageLink>
      {basketUrl ? (
        <ImageLink href={basketUrl} label="Return to basket" width={24}>
          <ShoppingCart />
        </ImageLink>
      ) : null}
    </Styled.InnerWrapper>
  </Styled.Header>
);
